import { BLACK_HOLE } from 'utils/constants';

const GoldenTower = ({ unlocked, showAll }) => (
  <div className='weapon'>
    {!showAll && <div className='title'>You should pick Golden Tower</div>}
    {showAll && <div className='title'>Golden Tower</div>}
    {(showAll || !unlocked[BLACK_HOLE]) && (
      <div className='info'>
        You will want to keep looking for Black Hole. You may want to put a few
        cheap upgrades in bonus and duration early on, but your priority should
        be getting both, and syncing them (by getting their cooldowns to be
        identical).
      </div>
    )}
  </div>
);

export default GoldenTower;
